import { bool, func, string } from "prop-types";
export var textareaTypes = {
  id: string.isRequired,
  type: string,
  name: string,
  value: string,
  className: string,
  autoComplete: string,
  isDisabled: bool,
  isReadOnly: bool,
  placeholder: string,
  onChange: func,
  onKeyPress: func,
  onFocus: func,
  onBlur: func,
  required: bool,
  minLength: string,
  maxLength: string,
  autoFocus: bool,
  dataSpacer: string,
  hasError: bool,
  noResize: bool
};